import React from 'react'
import './Chat.css'

const Chat = () => {
  return (
    <div className="chat_container">Chat</div>
  )
}

export default Chat